'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _codePoint = require('./codePoint');

var _codePoint2 = _interopRequireDefault(_codePoint);

var _hashtagAlphaNumeric = require('./hashtagAlphaNumeric');

var _hashtagAlphaNumeric2 = _interopRequireDefault(_hashtagAlphaNumeric);

var _regexSupplant = require('../lib/regexSupplant');

var _regexSupplant2 = _interopRequireDefault(_regexSupplant);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var hashtagBoundary = (0, _regexSupplant2.default)(/(?:^|\uFE0E|\uFE0F|$|(?!#{hashtagAlphaNumeric}|&)#{codePoint})/, {
  codePoint: _codePoint2.default,
  hashtagAlphaNumeric: _hashtagAlphaNumeric2.default
}); // Copyright 2018 Twitter, Inc.
// Licensed under the Apache License, Version 2.0
// http://www.apache.org/licenses/LICENSE-2.0

exports.default = hashtagBoundary;
module.exports = exports['default'];